<template>
  <el-dialog
    :title="`Receta electrónica código: [${formatId}]`"
    :visible="visible"
    width="80%"
    class="prescription-preview-dialog"
    :before-close="handleClosePrescriptionDialog">
    <div v-loading="loadingPrescription" class="prescription-preview-dialog__preview-frame">
      <prescription-preview
        v-if="visible && prescriptionId"
        :prescription-id="prescriptionId"
        height="450px"
        @prescription-loaded="handlePrescriptionPreviewLoaded" />
    </div>
    <slot slot="footer" name="footer" />
  </el-dialog>
</template>

<script>
import PrescriptionPreview from '@/components/prescription/PrescriptionPreview';
export default {
  name: 'PrescriptionPreviewDialog',
  components: { PrescriptionPreview },
  props: {
    prescriptionId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingPrescription: true,
      formatId: '',
    };
  },
  updated(){
    this.formatId = this.prescriptionId.match(/(.{5})/g).join("-");
  },
  methods: {
    handlePrescriptionPreviewLoaded() {
      this.loadingPrescription = false;
    },
    handleClosePrescriptionDialog() {
      this.loadingPrescription = true;
      this.$emit('close-dialog');
    }
  }
};
</script>

<style lang="scss">
.prescription-preview-dialog {
  &__preview-frame {
    min-height: 450px;
  }
}
</style>
